<template>
	<Head title="Companies and Organizations" />
	<MainLayout>
		<section class="dt-home">
			<div class="container">
				<div class="dt-home-wrapper flex flex-col gap-y-6">
					<!-- Top Bar -->
					<TopBar :sectors="props.sectors_list" :sizes="props.sizes_list" :countries="props.countries_list" />
					<!-- Top Bar end -->
					<!-- <div class="dt-home-search-results">
                        <ul class="list-none flex flex-wrap gap-4">
                            <li class="dt-home-search-results-item leading-none flex flex-wrap gap-x-2">
                                <span class="dt-home-search-results-item-heading text-[12px] font-medium font-roboto text-night_rider leading-[1.25] inline-block"> Headquarters :</span>
                                <span class="text-[12px] text-dark_gray inline-block font-regular font-roboto leading-[1.25]">Bangladesh Industries</span>
                            </li>
                            <li class="dt-home-search-results-item leading-none flex flex-wrap gap-x-2">
                                <span class="dt-home-search-results-item-heading text-[12px] font-medium font-roboto text-night_rider leading-[1.25] inline-block"> Industries :</span>
                                <span class="text-[12px] text-dark_gray inline-block font-regular font-roboto leading-[1.25]">Industries Test</span>
                            </li>
                            <li class="dt-home-search-results-item leading-none flex flex-wrap gap-x-2">
                                <span class="dt-home-search-results-item-heading text-[12px] font-medium font-roboto text-night_rider leading-[1.25] inline-block"> Company sizes :</span>
                                <span class="text-[12px] text-dark_gray inline-block font-regular font-roboto leading-[1.25]">Company sizes Test</span>
                            </li>
                        </ul>
                    </div> -->
					<div v-if="props.rows.data" class="dt-home-companies">
						<CompanyCard v-for="row in props.rows.data" :key="row.id" :row="row"></CompanyCard>
					</div>
					<div class="dt-home-pagination">
						<el-pagination
							background
							layout="total, prev, pager, next"
							:total="props.rows.total"
							@size-change="handleSizeChange"
							@current-change="handleCurrentChange"
							v-model:current-page="filter.page"
							v-model:page-size="filter.per_page"
						/>
					</div>
				</div>
			</div>
		</section>
	</MainLayout>
</template>

<script setup>
import CompanyCard from "@/components/Company/CompanyCard.vue";
import TopBar from "@/components/Company/TopBar.vue";
import MainLayout from "@/layouts/MainLayout.vue";
import filter from "@/pages/Company/filter";
import { Head, router } from "@inertiajs/vue3";
import { onMounted, onUnmounted, ref, watch } from "vue";

const props = defineProps({
	rows: { type: Object },
	sizes_list: { type: Object },
	sectors_list: { type: Object },
	countries_list: { type: Object },
	countries: { type: String },
	sizes: { type: String },
	column: { type: String },
	sort: { type: String },
	search: { type: String },
});

const page_sizes = [10, 24, 48, 96, 192, 384];
// const customLayout = ref('');
const pager_count = ref(7);

const handleSizeChange = (val) => {
	console.log(`${val} items per page`);
	filter.value.per_page = val;
	getCompanies();
};

const handleCurrentChange = (val) => {
	console.log(`current page: ${val}`);
	filter.value.page = val;
	getCompanies();
};

const getCompanies = () => {
	let url = new URL(route("companies-list"));
	url.searchParams.append("search", filter.value.search);
	url.searchParams.append("page", filter.value.page);
	url.searchParams.append("per_page", filter.value.per_page);
	url.searchParams.append("countries", filter.value.selectedCountries);
	url.searchParams.append("industries", filter.value.selectedSectors);
	url.searchParams.append("sizes", filter.value.selectedSizes);
	url.searchParams.append("sort", filter.value.sort);

	router.visit(url, {
		preserveScroll: true,
		preserveState: true,
		replace: true,
	});
};

watch(
	() => filter.value.reload,
	(newValue, oldValue) => {
		// console.log(filter.value);
		getCompanies();
	},
	// { deep: true }
);

const myEventHandler = (e) => {
	if (window.innerWidth > 425) {
		// customLayout.value = 'total, sizes, prev, pager, next';
		pager_count.value = 7;
	} else {
		// customLayout.value = 'prev, pager, next';
		pager_count.value = 5;
	}

	//   console.log('e:', window.innerWidth, customLayout.value);
};

onMounted(() => {
	//   filter.value.industries = splitNumber(props.industries);
	//   filter.value.countries = splitNumber(props.countries);
	filter.value.sizes = props.sizes ? [props.sizes] : [];
	filter.value.search = props.search;
	filter.value.page = props.rows.current_page;
	filter.value.total = props.rows.total;
	filter.value.per_page = props.rows.per_page;
	filter.value.column = "name";
	filter.value.sort = props.sort;
	filter.value.loading = false;
	myEventHandler();

	window.addEventListener("resize", myEventHandler);
});

onUnmounted(() => {
	window.removeEventListener("resize", myEventHandler);
});
</script>
